export default __webpack_public_path__ + "static/media/sponsor-bg-2-cn.9c15d51d.webp";